<template>
  <div v-if="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    icon: {
      required: false
    },
    name: {
      required: false
    },
    selected: {
      default: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  mounted () {
    this.isActive = this.selected
  },
  created () {
    const self = this

    this.$parent.$emit('tabs', {'name': this.name, 'icon': this.icon, 'isActive': this.selected})

    this.$parent.$on('tabSelected', name => {
      self.isActive = self.name === name
    })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/tab/tab.vue